// extracted by mini-css-extract-plugin
export default {"wrapper":"FunctionTitle_wrapper__3K7Yx","title":"FunctionTitle_title__Ajwh8"};